var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownloadinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.24 16a3.843 3.843 0 01-3.84 3.84h-3.2a.64.64 0 110-1.28h3.2A2.563 2.563 0 0024.96 16a2.563 2.563 0 00-2.56-2.56.642.642 0 01-.64-.64 2.563 2.563 0 00-2.56-2.56 2.54 2.54 0 00-.691.109.637.637 0 01-.698-.25A4.175 4.175 0 0014.4 8.32a4.164 4.164 0 00-4.16 4.16c0 .074.006.147.01.22a.703.703 0 01-.17.51c-.131.137-.294.243-.509.23A2.564 2.564 0 007.04 16a2.563 2.563 0 002.56 2.56h3.2a.64.64 0 110 1.28H9.6A3.843 3.843 0 015.76 16c0-1.9 1.389-3.485 3.206-3.789A5.449 5.449 0 0114.4 7.04c1.626 0 3.162.733 4.192 1.978.211-.039.41-.058.608-.058a3.849 3.849 0 013.795 3.245A3.849 3.849 0 0126.24 16zm-8.771 5.949l-.829.825V14.72a.642.642 0 00-.64-.64.642.642 0 00-.64.64v8.054l-.829-.828a.641.641 0 00-.905.905l1.92 1.92a.638.638 0 00.906 0l1.92-1.92a.641.641 0 000-.905.634.634 0 00-.903.003z",
    fill: "#fff"
  })));
}

export default SvgDownloadinline;